import clsx from 'clsx';
import React from 'react';

import { topic_landing_path } from '@routes';
import { encodeEntity } from '@utils/formatting';
import { AutocompleteRecord } from '@utils/interfaces';

import styles from './styles.module.scss';

interface ForumTagsProps {
  tags: AutocompleteRecord[];
  small?: boolean;
}

export default function ForumTags({ tags, small }: ForumTagsProps) {
  return (
    <div
      className={clsx(styles.tags, {
        [styles.smallTags]: small,
      })}
    >
      {tags.slice(0, 5).map((tag) => (
        <a
          href={topic_landing_path(encodeEntity(tag.label))}
          key={tag.value}
          className={styles.tag}
        >
          #{tag.label}
        </a>
      ))}
    </div>
  );
}
